import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components/macro';
import { useTranslate } from '../../contexts/languageContext';
import { parseaFechaHora, addDot, getUrl } from '../../utils';
import constantes from '../../resources/constantes';
import { themes } from '../../styles/themes';
import { getNomenclatorColorsByElecCode } from '../../utils/nomenclatorUtils';
import { Link } from 'react-router-dom';
import './styles.css';
import Ini1 from '../../assets/img/ini1-90w.jpg';
import Ini2 from '../../assets/img/ini2-90w.jpg';
import Ini3 from '../../assets/img/ini3-90w.jpg';
import Ini4 from '../../assets/img/ini4-90w.jpg';
import Ini5 from '../../assets/img/ini5-90w.jpg';
import Ini1_2x from '../../assets/img/ini1-180w.jpg';
import Ini2_2x from '../../assets/img/ini2-180w.jpg';
import Ini3_2x from '../../assets/img/ini3-180w.jpg';
import Ini4_2x from '../../assets/img/ini4-180w.jpg';
import Ini5_2x from '../../assets/img/ini5-180w.jpg';
import Ini1_3x from '../../assets/img/ini1-270w.jpg';
import Ini2_3x from '../../assets/img/ini2-270w.jpg';
import Ini3_3x from '../../assets/img/ini3-270w.jpg';
import Ini4_3x from '../../assets/img/ini4-270w.jpg';
import Ini5_3x from '../../assets/img/ini5-270w.jpg';
import { responsive } from '../../resources/constantes.json';
import getUrlResultados from '../../utils/getUrlResultados';
import { motion } from 'framer-motion';
/**
 * Tarjetas mostradas en inicio que nos permiten conocer información
 * sobre cada elección en una sola pantalla
 */

const Tarjeta = props => {
  const t = useTranslate();
  const nombreEleccion = constantes.nombreEleccion;
  const nomenclatorColors = getNomenclatorColorsByElecCode(
    props.nomenclator,
    props.elec
  );
  const regex = /\/(\d+)\/(.*)/;
  const match = props.location.pathname.match(regex);
  const rutaAdicional = match && match[2] ? match[2] : '';
  const url = getUrlResultados(props.pairElectionAmbito, rutaAdicional).replace(
    '//',
    '/'
  );
  const [colorBorde, setColorBorde] = useState(nomenclatorColors.c);
  const [hora, , fecha] = parseaFechaHora(props.mdhm).split(' ');
  useEffect(() => {
    setColorBorde(nomenclatorColors.c);
  }, [nomenclatorColors.c]);
  return (
    <TarjetaContainer>
      <motion.div
        variants={{
          first: { translateX: 30, opacity: 0 },
          idle: { translateX: 0, opacity: 1 },
        }}
        transition={{ delayChildren: 1 }}
      >
        <SLink to={url} style={{ textDecoration: 'none' }}>
          <Border
            variants={{
              start: { backgroundColor: themes.inicio.backgroundColor },
              end: { backgroundColor: colorBorde },
            }}
            transition={{ ease: 'backInOut' }}
            colorHover={nomenclatorColors.cs}
            onTouchStart={() => setColorBorde(nomenclatorColors.cs)}
            onTouchEnd={() => setColorBorde(nomenclatorColors.c)}
          >
            <InfoContainer>
              <STarjetaHeader>
                <h3>{t(nombreEleccion[props.elec])}</h3>
                <div
                  style={{
                    fontWeight: 400,
                    display: 'flex',
                    columnGap: '4px',
                    flexWrap: 'wrap',
                  }}
                >
                  <span>{t('datos') + ' ' + t('aLas')}</span>
                  <span style={{ fontWeight: 700, color: '#E40424' }}>
                    {hora}
                  </span>
                  <span>{fecha}</span>
                </div>
                <div
                  style={{
                    padding: '10px 20px',
                    backgroundColor: themes.tarjetasInicio.linkBtn,
                    minWidth: 'fit-content',
                    color: 'white',
                    fontSize: '1.6rem',
                    fontWeight: 500,
                    borderRadius: '20px',
                    marginTop: '14px',
                    textAlign: 'center',
                  }}
                >
                  {t('botonEnlaceInicio')}
                </div>
              </STarjetaHeader>
              <STarjetaContent>
                <STarjetaContentColumn>
                  <h4>{t('votos').toUpperCase()}</h4>
                  <div style={{ fontSize: '2.4rem', fontWeight: 700 }}>
                    {props.totales.act.pvotant}
                  </div>
                  <div>
                    <SmallText>
                      <span>{addDot(props.totales.act.centota)}</span>
                      <span>{t('potencial')}</span>
                    </SmallText>
                    <SmallText>
                      <span>{addDot(props.totales.act.votant)}</span>
                      <span>{t('votantes').toLowerCase()}</span>
                    </SmallText>
                  </div>
                </STarjetaContentColumn>
                <STarjetaContentColumn>
                  <h4>{t('mesas').toUpperCase()}</h4>
                  <div style={{ fontSize: '2.4rem', fontWeight: 700 }}>
                    {props.totales.act.pmesesc}
                  </div>
                  <div>
                    <SmallText>
                      <span>{addDot(props.totales.act.metota)}</span>
                      <span>{t('instaladas')}</span>
                    </SmallText>
                    <SmallText>
                      <span>{addDot(props.totales.act.mesesc)}</span>
                      <span>{t('informadas')}</span>
                    </SmallText>
                  </div>
                </STarjetaContentColumn>
              </STarjetaContent>
            </InfoContainer>
          </Border>
        </SLink>
      </motion.div>
    </TarjetaContainer>
  );
};

const TarjetasInicio = props => {
  return (
    <DivTarjetas
      animate={['idle', 'end']}
      initial={['first', 'start']}
      exit={['first', 'start']}
      transition={{ staggerChildren: 0.3, delay: 0.2 }}
    >
      {props.data.map((x, index) => (
        <Tarjeta
          {...x}
          key={`elec-card-${x.elec}`}
          nomenclator={props.nomenclator}
          ambito={props.ambito}
          pairElectionAmbito={props.arrayPairElectionAmbito[index]}
          location={props.location}
        />
      ))}
    </DivTarjetas>
  );
};

export default TarjetasInicio;
const DivTarjetas = styled(motion.div)`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  @media (max-width: ${responsive.mobile}px) {
    padding: 0px 10px;
  }
  @media (max-width: 1200px) {
    margin-top: 30px;
  }
`;
const SFoto = styled.figure`
  margin-right: 2.5rem;
  height: 10.95rem;
  margin-bottom: 0.5rem;
  background: rgba(0, 0, 0, 0.08);
  & img {
    object-fit: contain;
    width: 9rem;
  }
`;

const STarjetaHeader = styled.header`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  & h3 {
    font-weight: 700;
    font-size: 2.4rem;
    line-height: 2rem;
  }
  padding: 25px 16px;
`;

const STarjetaContent = styled.div`
  display: flex;
  margin-right: auto;
  margin-left: auto;
  column-gap: 30px;
  padding: 30px 16px;
  & div {
    width: 100%;
  }
  & div h4 {
    font-size: 1.6rem;
    font-weight: 700;
  }
  & > div > div:nth-child(2) {
    font-size: 2.5rem;
    font-weight: 900;
  }
  @media (max-width: ${responsive.mobile}px) {
    margin: 0;
  }

  @media (max-width: ${449}px) {
    flex-direction: column;
    gap: 2rem;
    padding: 0 2rem 2rem 2rem;

    & div {
      width: 100%;
      text-align: center;
      justify-content: center;
    }
  }
`;
const STarjetaContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  & div {
    font-weight: 400;
  }
`;
const TarjetaContainer = styled.article`
  font-size: 1.4rem;
  padding: 0 10px;
  background-color: transparent;
  transition-duration: 250ms;
  overflow-x: hidden;
  @media (min-width: 1200px) {
    &:hover {
      transform: scale(1.02);
      text-decoration: none;
      // z-index: 10000;
      cursor: pointer;
    }
  }
  @media (min-width: 1400px) {
    &:hover {
      transform: scale(1.05);
    }
  }
`;

const Border = styled(motion.div)`
  // background-color: ${({ color }) => color};
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 25px;
  padding-left: 5%;
  @media (min-width: 1200px) {
    &:hover {
      transition: background-color .1s;
      background-color: ${({ colorHover }) => colorHover};
    }
  }
`;
const InfoContainer = styled.div`
  color: ${themes.inicio.base};
  @media (max-width: ${responsive.mobile}px) {
    padding: 6px 10px;
  }
  background-color: ${themes.inicio.backgroundColor};
  padding: 0px 30px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  display: flex;
  justify-content: space-between;
  @media (max-width: ${responsive.mobile}px) {
    flex-direction: column;
  }
  @media (max-width: 1550px) {
    padding: 0px 10px;
  }
`;
const SLink = styled(Link)`
  color: #222;
  text-decoration: none;
`;

const EfectoHover = styled.div`
  position: absolute;
  height: 10.95rem;
  width: 9rem;
`;

const Cover = styled.div`
  height: 8.95rem;
  background: rgba(0, 0, 0, 0.25);
`;

const Text = styled.div`
  text-align: center;
  text-transform: uppercase;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.1rem;
  font-weight: bold;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
`;

const SmallText = styled.div`
  display: flex;
  column-gap: 4px;
  font-weight: 600;
`;

const getImagenes = elec => {
  switch (elec) {
    case '1':
      return [Ini1, Ini1_2x, Ini1_3x];
    case '2':
      return [Ini2, Ini2_2x, Ini2_3x];
    case '3':
      return [Ini3, Ini3_2x, Ini3_3x];
    case '4':
      return [Ini4, Ini4_2x, Ini4_3x];
    case '5':
      return [Ini5, Ini5_2x, Ini5_3x];
    default:
      return null;
  }
};
